import { TIMEOUT_SECONDS } from './config.js';
import { uploadRecipe } from './model.js';

const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};

export const AJAX = async function (url, uploadData = undefined) {
  //Prepare fetchPro for POST request if uploadData is specified, otherwise prepare
  //for GET
  const fetchPro = uploadData
    ? fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(uploadData),
      })
    : fetch(url);

  //timeout handling for API request
  const res = await Promise.race([fetchPro, timeout(TIMEOUT_SECONDS)]);
  //Convert to json
  const data = await res.json();

  //Alert error in API call
  if (!res.ok) throw new Error(`${data.message} (${res.status})`);
  return data;
};

/*
export const getJSON = async function (url) {
  try {
    //Call for recipe, with timeout handling
    const res = await Promise.race([fetch(url), timeout(TIMEOUT_SECONDS)]);
    //Convert to json
    const data = await res.json();

    //Alert error in API call
    if (!res.ok) throw new Error(`${data.message} (${res.status})`);
    return data;
  } catch (err) {
    throw err;
  }
};

export const sendJSON = async function (url, uploadData) {
  try {
    const fetchPro = fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(uploadData),
    });
    //POST recipe, with timeout handling
    const res = await Promise.race([fetchPro, timeout(TIMEOUT_SECONDS)]);
    //Convert to json
    const data = await res.json();

    //Alert error in API call
    if (!res.ok) throw new Error(`${data.message} (${res.status})`);
    return data;
  } catch (err) {
    throw err;
  }
};
*/
